import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import './style.less';
import { history } from 'umi';
import ErrorBoundary from './ErrorBoundary';
import React from 'react';
// import VConsole from 'vconsole';
// new VConsole();

dayjs.locale('zh-cn');

export const request = {
  timeout: 20000,
  errorConfig: {
    adaptor: (response) => {
      return {
        success: response.successful,
        data: response,
        errorCode: response.code,
        errorMessage: response.message,
        showType: 2,
      };
    },
  },
  // middlewares: [],
  // requestInterceptors: [
  //   (url, options) => {
  //     return {
  //       url: `https://api.morecanai.com${url}`,
  //       options: {
  //         ...options,
  //         headers: {
  //           Authorization: `Bearer ${window.localStorage.getItem(
  //             'access_token',
  //           )}`,
  //         },
  //         interceptors: true,
  //       },
  //     };
  //   },
  // ],
  // responseInterceptors: [],
};

export function rootContainer(container) {
  return React.createElement(ErrorBoundary, null, container);
}
